import React from "react"

export default function Container({
    shadow = false,
    children,
    radius,
    bgColor = "white",     
    className = "",
    ...props
}) {
    const radiusMap = {
        none: "",
        sm: "rounded-sm",
        md: "rounded-md",
        lg: "rounded-lg",
        xl: "rounded-xl",
        full: "rounded-full",
    }

    const bgMap = {
        white: "bg-white",
        transparent: "bg-transparent",
        "gray-50": "bg-gray-50",
        "gray-100": "bg-gray-100",
        "gray-200": "bg-gray-200",
        "gray-300": "bg-gray-300",
        "gray-700": "bg-gray-700",
        "yellow-100": "bg-yellow-100",
        second: "bg-second",
        second_light: "bg-second_light",
        main: "bg-main",
        main_light: "bg-main_light",
        main_dark: "bg-main_dark",
    }

    const containerClass =
        `${shadow && "shadow"} ${radiusMap[radius] || ""} ${bgMap[bgColor] || bgColor || ""} ${className}`

    return (
        <div className={containerClass} {...props}>
            {children}
        </div>
    )
}
